// Convert imprint and data protection to modals
document.querySelectorAll(".modal.service.fade").forEach(e => {
    const id = e.id;
    console.log(id);
    document.querySelectorAll('a[href="/'+id+'"]').forEach(e => {
        e.setAttribute('data-bs-toggle', 'modal');
        e.setAttribute('href', '#'+id);
        console.log(e);
    });
});

// Show messages
const modalElement = document.getElementById('messageModal');

if(modalElement) {
    const messageModal = new bootstrap.Modal(modalElement);
    messageModal.show();
}

// Set classes for scrolling
const bttbtn = document.getElementById("BackToTop");

window.onscroll = () => {
    if(window.scrollY > 25){
        document.body.classList.add('scroll');
    } else {
        document.body.classList.remove('scroll');
    }

    if(window.scrollY > 500){
        bttbtn.classList.remove('opacity-0');
    } else {
        bttbtn.classList.add('opacity-0');
    }
}

// Initialize animate on scroll
AOS.init({
    delay: 50,
    duration: 500,
    easing: 'ease-in-out',
});
